import { render, staticRenderFns } from "./QuestionChoiceSelector.vue?vue&type=template&id=52175bea"
import script from "./QuestionChoiceSelector.vue?vue&type=script&lang=js"
export * from "./QuestionChoiceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports